export default "__VITE_ASSET__DA6H_Emm__"